export default __webpack_public_path__ + "locales/ja-JP/SocialAuthWelcomeDialog.json?hash=5a4d04c469dd57478ac8a10d05e9af4b";